import { inject, Injectable } from '@angular/core';
import { JsonApiResourceMapper, ResourceCollection, ResourceIdentifierMapperService, ResourceMapper, ResourceTypes } from '@big-direkt/json-api-client';
import { CustomersVoiceTaxonomyModel, ParagraphTypes } from '@big-direkt/utils/shared';
import { CustomersVoiceModel } from './customers-voice.model';
import { CustomersVoiceResource } from './customers-voice.resource';

@Injectable({
    providedIn: 'root',
})
@JsonApiResourceMapper
export class CustomersVoiceMapper extends ResourceMapper<CustomersVoiceModel> {
    public static override readonly type: ResourceTypes = ResourceTypes.ParagraphBigCustomersVoice;

    private readonly resourceIdentifierMapper = inject(ResourceIdentifierMapperService);

    public map(resource: CustomersVoiceResource, collection: ResourceCollection): CustomersVoiceModel {
        const praragraph: CustomersVoiceModel = {
            type: ParagraphTypes.CustomersVoice,
            loadCustomerVoices: resource.attributes.load_customer_voices ?? true,
            title: resource.attributes.title ?? undefined,
            text: resource.attributes.text?.processed ?? undefined,
            directoryTitle: resource.attributes.title ?? undefined,
            customerVoices:
                this.resourceIdentifierMapper.mapMultiple<CustomersVoiceTaxonomyModel>(resource.relationships.customers_voices.data, collection) ?? [],
        };

        return praragraph;
    }
}
